// hooks/useAppVersionStatus.ts
// import { useAppVersionStore, MIN_VERSION } from 'stores/useAppVersionStore'
// import { useCurrentUser } from './useCurrentUser'
import { MIN_VERSION, useAppVersionStore } from '../../store/useAppVersionStore'

// compareVersions 재사용
const compareVersions = (v1: string | null | undefined, v2: string): 1 | 0 | -1 => {
  const a = (v1 ?? '0.0.0').split('.').map(Number)
  const b = v2.split('.').map(Number)
  const len = Math.max(a.length, b.length)
  for (let i = 0; i < len; i++) {
    const n1 = a[i] || 0
    const n2 = b[i] || 0
    if (n1 > n2) return 1
    if (n1 < n2) return -1
  }
  return 0
}

/**
 * 사용자 이메일이 ringleplus 도메인에 속해 있고,
 * 앱 버전이 MIN_VERSION 이상일 때만 true
 */
export const useIsOkToUse = (): boolean => {
  const appVersion = useAppVersionStore((s) => s.appVersion)
  // const { currentUser } = useCurrentUser()

  //don't use currentUser..
  // 아직 둘 중 하나가 없으면 false
  if (!appVersion) return false

  // const isRingleUser = currentUser.email.includes('ringleplus')
  // const isRingleUser = true

  const versionOk = compareVersions(appVersion, MIN_VERSION) >= 0

  return versionOk
}
